// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NLQSavePopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { PureComponent, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import actions from './Izenda.NLQSavePopupActions';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Label from 'share/components/controls/Izenda.Label';
import DropDown from "share/components/controls/Izenda.DropDown";
import Select from "share/components/controls/multiSelectBox/Izenda.Select";
import Constants from "logic/data/Izenda.ReportDesignerConstants";
import Loading from "share/components/controls/Izenda.Loading";

import { sortBy } from "lodash/fp";
import Validator from "share/components/hoc/Izenda.Validator";
import Input from "share/components/controls/Izenda.Input";
const ValidatorInput = Validator()(Input);

@connect(actions)
class NLQSavePopup extends PureComponent {

  componentDidMount() {
    const { store, reportName, setReportName, updateSaveInto } = this.props;
    store.loadCategorySettings();
    if (store.isNewReport) {
      const isReportType =
        store.model.reportType === Constants.REPORT_TYPE_ENUM.REPORT;
      const reportDefaultName = isReportType
        ? Constants.DEFAULT_REPORT_NAME
        : Constants.DEFAULT_TEMPLATE_NAME;
      if (reportName === Constants.DEFAULT_REPORT_NAME) {
        setReportName(reportDefaultName);
      }
    } else {
      // The default value of SaveInto depends on Global Report checkbox.
      // But when "save as" an exist report, it's default to local category
      updateSaveInto(Constants.GLOBAL_REPORT_ENUM.LOCAL);
    }
  }
 
  onReportNameChanged = (event: any) => {
    this.props.setReportName(event.target.value);
    this.props.setReportNameErrorMsg('');
    this.props.setReportNameErrorCls(false);
  };

  onChangedReportTitleName = (event: any) => {
    this.props.onChangeReportPartTitleName(event.target.value);
  };

  onReportNameFocus = (event: FocusEvent) => {
    event.target.select();
  };

  onReportNameKeyPress = (event: KeyboardEvent) => {
    const close = () => this.props.hide();
    const closeThisModal = type => this.props.onClosing && this.props.onClosing(close, type);
    switch (event.key) {
      case 'Enter':
        closeThisModal('accept');
        break;
    }
  };

  onReportTypeChanged = (event: any) => {
    this.props.changeReportType(event.target.value);
  };

  onSaveIntoChanged = (event: any) => {
    this.props.updateSaveInto(event.value);
  };

  onCategoryChanged = (id: string, name: string) => {
    this.props.changeCategory(id, name);
  };

  changeAdvancedOptionFun = () => {
    this.props.setShowAdvancedOption(true);
  };

  renderContainer = () => {
    const { store, localizer, showAdvancedOption, authorization,
      authorizationConstants, addNewCategory, addNewSubCategory, reportName, reportPartTitleName,
      saveInto, reportNameErrorMsg, reportNameErrorCls
     } = this.props;
    const model = store.model;
    let types = model.types;
    const categories = sortBy(cat => cat.name.toLowerCase(), model.categories);
    const isReportType = model.reportType === Constants.REPORT_TYPE_ENUM.REPORT;
    const hasPrivilege = authorization.checkPrivileges([
      authorizationConstants.PERMISSION_KEY.ReportsCanCreateNewCategoryValue
    ]);

    let onAddNewCategory = addNewCategory;
    let noResultsTextCategory = Constants.HINT_MESSAGE.CATEGORY;
    let onAddNewSubCategory = addNewSubCategory;
    let noResultsTextSubCategory = Constants.HINT_MESSAGE.SUB_CATEGORY;
    if (!hasPrivilege) {
      onAddNewCategory = false;
      noResultsTextCategory = null;
      onAddNewSubCategory = false;
      noResultsTextSubCategory = null;
    }

    const reportNameVals = isReportType
      ? Constants.CONSTRAINTS.REPORT_NAME
      : Constants.CONSTRAINTS.TEMPLATE_NAME;
    const GLOBAL_REPORT = [
      {
        value: Constants.GLOBAL_REPORT_ENUM.LOCAL,
        label: store.localReportName
      },
      {
        value: Constants.GLOBAL_REPORT_ENUM.GLOBAL,
        label: store.globalReportName
      }
    ];
    let selectedReportNameErrorCls = reportNameErrorCls ?  'error-text': '';
    return (
      <GridLayout className='form-horizontal nlq-form'>
        <GridLayout.Row>
          <GridLayout.Col cols='12'>
            <div className='labtxt'>{localizer.getText('NLQ_SAVE_POPUP_CHOOSE_LABEL')}</div>
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols='6'>
            <div className='labreport'>
              <Label className='control-label' for='report'>
                <input
                  type='radio'
                  className='nwcusradio'
                  checked={store.model.reportType == 0}
                  value={0}
                  id='report'
                  name='labreport'
                  onChange={this.onReportTypeChanged}
                />
                {types[0].name}
              </Label>
            </div> 
          </GridLayout.Col>
          <GridLayout.Col cols='6'>
            <div className='labreport'>
              <Label className='control-label' for='template'>
                <input
                  type='radio'
                  className='nwcusradio'
                  checked={store.model.reportType == 1}
                  disabled
                  value={1}
                  id='template'
                  name='labreport'
                  onChange={this.onReportTypeChanged}
                />
                {types[1].name}
              </Label>
            </div>
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols={`12 ${selectedReportNameErrorCls}`}>
            <div className='labtxt'>{ store.model.reportType == 0 ? localizer.getText('NLQ_SAVE_POPUP_ADD_REPORT_NAME') : localizer.getText('NLQ_SAVE_POPUP_ADD_TEMPLATE_NAME')}<sup>*</sup></div>
            {reportNameErrorMsg &&  <span className="error-report-message-name">{reportNameErrorMsg}</span> }
            <ValidatorInput
              value={reportName}
              className="form-control"
              shouldFocus={false}
              onChange={this.onReportNameChanged}
              onFocus={this.onReportNameFocus}
              onKeyPress={this.onReportNameKeyPress.bind(this)}
              validations={reportNameVals}
              field="name"
              type="text"
              name="reportName"
            />
          </GridLayout.Col>
        </GridLayout.Row>
        {!showAdvancedOption ? 
        <GridLayout.Row>
          <GridLayout.Col cols='12 advanced-options-wrap'>
            <a onClick={this.changeAdvancedOptionFun}>
              {localizer.getText('NLQ_SAVE_ADVANCED_OPTIONS')}
           </a>
          </GridLayout.Col>
        </GridLayout.Row>
            : ''}
       {showAdvancedOption ? (
         <div>
        <GridLayout.Row>
          <GridLayout.Col cols='12'>
            <div className='labtxt'>{localizer.getText('NLQ_SAVE_POPUP_SAVE_TO')}</div>
            <DropDown
                options={GLOBAL_REPORT}
                onChange={this.onSaveIntoChanged}
                value={saveInto}
                valueField="value"
                labelField="label"
              />
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols='12'>
            <div className='labtxt'>{localizer.getText('NLQ_SAVE_SELECT_SUBCATEGORY')}</div>
            <Select
              simpleValue
              options={categories}
              labelKey="name"
              valueKey="id"
              value={store.model.categoryId}
              noResultsText={noResultsTextCategory}
              onChange={this.onCategoryChanged}
              onAddNew={onAddNewCategory}
              scalable={false}
            />
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols='12'>
            <div className='labtxt'>{localizer.getText('NLQ_SAVE_POPUP_ADD_REPORT_TITLE')}</div>
                <input
                  type='text'
                  className='form-control report-title-name'
                  value={reportPartTitleName}
                  name="reportPartTitleName"
                  onChange={this.onChangedReportTitleName}
                />
          </GridLayout.Col>
        </GridLayout.Row>
        </div>
        ) : ''}
      </GridLayout>
    );
  };

  render() {
    const { onClosing, localization } = this.props;
    const popupTitle = localization.getText('COMMON_LABEL_SAVE_AS');
    return (
      <Popup visible onClosing={onClosing} autoClose={false} type='none' sizeClass='explore-modal'>
        <Popup.Header title={popupTitle} />
        <Popup.Body>{this.renderContainer()}</Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton type='accept'>{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
          <Popup.ConfirmationButton type='cancel'>
            {localization.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}

export default NLQSavePopup;



// WEBPACK FOOTER //
// ./ui/share/components/controls/NLQSavePopup/Izenda.NLQSavePopup.js